import { Contract } from '@ethersproject/contracts'
import APR_CALCULATOR_ABI from 'abis/governance/APRCalculator.json'
import HYDRA_CHAIN_ABI from 'abis/governance/HydraChain.json'
import HYDRA_DELEGATION_ABI from 'abis/governance/HydraDelegation.json'
import HYDRA_STAKING_ABI from 'abis/governance/HydraStaking.json'
import HYDRA_VAULT_ABI from 'abis/governance/HydraVault.json'
import PRICE_ORACLE_ABI from 'abis/governance/PriceOracle.json'
import REWARD_WALLET_ABI from 'abis/governance/RewardWallet.json'
import {
  APR_CALCULATOR_ADDRESS,
  HYDRA_CHAIN_ADDRESS,
  HYDRA_DELEGATION_ADDRESS,
  HYDRA_STAKING_ADDRESS,
  HYDRA_VAULT_ADDRESS,
  PRICE_ORACLE_ADDRESS,
  REWARD_WALLET_ADDRESS,
} from 'constants/addresses'

import { useContract } from './useContract'

// Governance contract hooks
export function useHydraChainContract(withSignerIfPossible = true): Contract | null {
  return useContract(HYDRA_CHAIN_ADDRESS, HYDRA_CHAIN_ABI, withSignerIfPossible)
}

export function useHydraStakingContract(withSignerIfPossible = true): Contract | null {
  return useContract(HYDRA_STAKING_ADDRESS, HYDRA_STAKING_ABI, withSignerIfPossible)
}

export function useHydraDelegationContract(withSignerIfPossible = true): Contract | null {
  return useContract(HYDRA_DELEGATION_ADDRESS, HYDRA_DELEGATION_ABI, withSignerIfPossible)
}

export function useAPRCalculatorContract(withSignerIfPossible = true): Contract | null {
  return useContract(APR_CALCULATOR_ADDRESS, APR_CALCULATOR_ABI, withSignerIfPossible)
}

export function usePriceOracleContract(withSignerIfPossible = true): Contract | null {
  return useContract(PRICE_ORACLE_ADDRESS, PRICE_ORACLE_ABI, withSignerIfPossible)
}

export function useHydraVaultContract(withSignerIfPossible = true): Contract | null {
  return useContract(HYDRA_VAULT_ADDRESS, HYDRA_VAULT_ABI, withSignerIfPossible)
}

export function useRewardWalletContract(withSignerIfPossible = true): Contract | null {
  return useContract(REWARD_WALLET_ADDRESS, REWARD_WALLET_ABI, withSignerIfPossible)
}
